"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _all = require("animations-json/build/all");

var _LottieOutroBase = _interopRequireDefault(require("../../LottieOutroBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Outro03 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(Outro03, _AnimationBase);

  var _super = _createSuper(Outro03);

  function Outro03(animObj) {
    var _this;

    _classCallCheck(this, Outro03);

    var animationId = animObj.animationId,
        data = animObj.data,
        cdn = animObj.cdn;
    var config = {
      default: {
        colors: ['#fff', '#32BAFA']
      },
      inputs: ['action_01', 'action_02', 'website', 'disclaimer'],
      width: 1280,
      height: 720,
      fNameToReplace: ['Anton-Regular'],
      inDuration: 2000,
      intermissionDuration: 3000,
      outDuration: 0,
      totalDuration: 5000
    };
    _this = _super.call(this, animObj, data, config);
    var animation = (0, _all.getAnimationJson)(animationId); // set colors
    // change websit font color

    var websiteColorPattern = new RegExp('"fc":\\[1,1,0]', 'g');
    var webSiteColor = _this.colorsObj[1].luminosity() > 0.6 ? '"fc":[0,0,0]' : '"fc":[1,1,1]';
    animation = animation.replace(websiteColorPattern, webSiteColor); // replace with color 1

    var fontOneColorPattern = new RegExp('"fc":\\[0,1,0]', 'g'); // replace with color 2

    var shapeColorPattern = new RegExp('"sc":"#ffda3b"', 'g');
    var shapeColorPattern2 = new RegExp('\\[1,0.854901969433,0.23137255013,1]', 'g');
    animation = animation.replace(fontOneColorPattern, "\"fc\":[".concat(_this.colors[0], "]")).replace(shapeColorPattern, "\"sc\":\"".concat(_this.colorsObj[1].rgb(), "\"")).replace(shapeColorPattern2, "[".concat(_this.colors[1], "]"));
    animation = _this._setInputs(animation, data, config.inputs);
    animation = _this._setPackshot(animation, data, cdn);
    _this.json = JSON.parse(animation);
    return _this;
  }

  return Outro03;
}(_LottieOutroBase.default);

exports.default = Outro03;